import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid profile-permissions-matrix" }
const _hoisted_2 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "row g-2" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "col-md-8" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_11 = {
  key: 1,
  class: "fas fa-save"
}
const _hoisted_12 = {
  key: 1,
  class: "row"
}
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "matrix-container" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table table-bordered permissions-matrix" }
const _hoisted_17 = {
  class: "screen-header sticky-col",
  key: "main-screen-header"
}
const _hoisted_18 = { class: "d-flex flex-column gap-2" }
const _hoisted_19 = { class: "dropdown" }
const _hoisted_20 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_21 = ["id", "checked", "onChange"]
const _hoisted_22 = ["for"]
const _hoisted_23 = { class: "dropdown" }
const _hoisted_24 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_25 = ["id", "checked", "onChange"]
const _hoisted_26 = ["for"]
const _hoisted_27 = { class: "dropdown mt-2" }
const _hoisted_28 = { class: "form-check" }
const _hoisted_29 = ["checked"]
const _hoisted_30 = { class: "form-check" }
const _hoisted_31 = ["checked"]
const _hoisted_32 = { class: "form-check" }
const _hoisted_33 = ["checked"]
const _hoisted_34 = ["onMouseenter"]
const _hoisted_35 = { class: "profile-column" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "profile-name-rotated" }
const _hoisted_38 = { class: "form-check form-switch d-flex justify-content-center align-items-center my-2 px-0" }
const _hoisted_39 = ["id", "checked", "onChange", "disabled"]
const _hoisted_40 = {
  class: "add-profile-column",
  key: "add-profile-header"
}
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { class: "screen-info sticky-col" }
const _hoisted_43 = { class: "d-flex align-items-center justify-content-between w-100 position-relative" }
const _hoisted_44 = {
  class: "d-flex align-items-center gap-2",
  style: {"padding-right":"2rem"}
}
const _hoisted_45 = { class: "screen-icon" }
const _hoisted_46 = { class: "screen-details" }
const _hoisted_47 = { class: "screen-label" }
const _hoisted_48 = { class: "screen-key" }
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onMouseenter"]
const _hoisted_51 = { class: "d-flex justify-content-center align-items-center" }
const _hoisted_52 = ["id", "checked", "onChange", "disabled"]
const _hoisted_53 = { class: "row mt-3" }
const _hoisted_54 = { class: "col-12" }
const _hoisted_55 = { class: "d-flex justify-content-end" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_58 = {
  key: 1,
  class: "fas fa-save"
}
const _hoisted_59 = {
  key: 2,
  class: "row"
}
const _hoisted_60 = { class: "col-12 text-center py-5" }
const _hoisted_61 = {
  key: 3,
  class: "row"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.addMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[23] || (_cache[23] = _createElementVNode("h6", { class: "card-title" }, "Crear Nuevo Perfil", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "ID del Perfil (ej: academyManager)",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newProfile.profileId) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.newProfile.profileId]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveProfile())),
                      class: "btn btn-sm btn-success me-2 text-light",
                      disabled: _ctx.loading || !_ctx.newProfile.profileId
                    }, [
                      (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_10))
                        : (_openBlock(), _createElementBlock("i", _hoisted_11)),
                      _cache[21] || (_cache[21] = _createTextVNode(" Guardar ", -1))
                    ], 8, _hoisted_9),
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cancel())),
                      class: "btn btn-sm btn-secondary"
                    }, [...(_cache[22] || (_cache[22] = [
                      _createElementVNode("i", { class: "fas fa-times" }, null, -1),
                      _createTextVNode(" Cancelar ", -1)
                    ]))])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.addMode && _ctx.profiles.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("table", _hoisted_16, [
                  _createElementVNode("thead", null, [
                    _createVNode(_TransitionGroup, {
                      tag: "tr",
                      name: "column"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("th", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-outline-light w-100 d-flex justify-content-between align-items-center",
                                type: "button",
                                id: "columnDropdown",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false",
                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showColumnSelector = !_ctx.showColumnSelector), ["stop"]))
                              }, [...(_cache[24] || (_cache[24] = [
                                _createElementVNode("span", null, "Perfiles", -1),
                                _createElementVNode("i", {
                                  class: "fas fa-chevron-down ms-2",
                                  style: {"font-size":"0.7em"}
                                }, null, -1)
                              ]))]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["dropdown-menu p-2 w-100", { show: _ctx.showColumnSelector }]),
                                "aria-labelledby": "columnDropdown",
                                style: {"max-height":"200px","overflow-y":"auto"}
                              }, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("button", {
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selectAllProfiles && _ctx.selectAllProfiles(...args)), ["stop"])),
                                    class: "btn btn-xs btn-link text-decoration-none p-0",
                                    style: {"font-size":"0.75rem"}
                                  }, "Todos"),
                                  _createElementVNode("button", {
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deselectAllProfiles && _ctx.deselectAllProfiles(...args)), ["stop"])),
                                    class: "btn btn-xs btn-link text-decoration-none p-0 text-muted",
                                    style: {"font-size":"0.75rem"}
                                  }, "Ninguno")
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profiles, (p) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "form-check",
                                    key: p.profileId
                                  }, [
                                    _createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      id: 'col-vis-' + p.profileId,
                                      checked: !_ctx.hiddenProfileIds.includes(p.profileId),
                                      onChange: ($event: any) => (_ctx.toggleColumnVisibility(p.profileId))
                                    }, null, 40, _hoisted_21),
                                    _createElementVNode("label", {
                                      class: "form-check-label text-wrap",
                                      for: 'col-vis-' + p.profileId,
                                      style: {"font-size":"0.8rem"}
                                    }, _toDisplayString(p.profileId), 9, _hoisted_22)
                                  ]))
                                }), 128))
                              ], 2)
                            ]),
                            (_ctx.showColumnSelector)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "dropdown-backdrop",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showColumnSelector = false))
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-outline-light w-100 d-flex justify-content-between align-items-center",
                                type: "button",
                                id: "menuDropdown",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false",
                                onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.showMenuSelector = !_ctx.showMenuSelector), ["stop"]))
                              }, [...(_cache[25] || (_cache[25] = [
                                _createElementVNode("span", null, "Pantallas", -1),
                                _createElementVNode("i", {
                                  class: "fas fa-chevron-down ms-2",
                                  style: {"font-size":"0.7em"}
                                }, null, -1)
                              ]))]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["dropdown-menu p-2 w-100", { show: _ctx.showMenuSelector }]),
                                "aria-labelledby": "menuDropdown",
                                style: {"max-height":"250px","overflow-y":"auto"}
                              }, [
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("button", {
                                    onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selectAllMenus && _ctx.selectAllMenus(...args)), ["stop"])),
                                    class: "btn btn-xs btn-link text-decoration-none p-0",
                                    style: {"font-size":"0.75rem"}
                                  }, "Todos"),
                                  _createElementVNode("button", {
                                    onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.deselectAllMenus && _ctx.deselectAllMenus(...args)), ["stop"])),
                                    class: "btn btn-xs btn-link text-decoration-none p-0 text-muted",
                                    style: {"font-size":"0.75rem"}
                                  }, "Ninguno")
                                ]),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedMenus, (screen) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "form-check",
                                    key: 'filter-' + screen.Key
                                  }, [
                                    _createElementVNode("input", {
                                      class: "form-check-input",
                                      type: "checkbox",
                                      id: 'menu-vis-' + screen.Key,
                                      checked: !_ctx.hiddenMenuKeys.includes(screen.Key),
                                      onChange: ($event: any) => (_ctx.toggleMenuVisibility(screen.Key))
                                    }, null, 40, _hoisted_25),
                                    _createElementVNode("label", {
                                      class: "form-check-label text-wrap",
                                      for: 'menu-vis-' + screen.Key,
                                      style: {"font-size":"0.8rem"}
                                    }, _toDisplayString(screen.Label), 9, _hoisted_26)
                                  ]))
                                }), 128))
                              ], 2)
                            ]),
                            (_ctx.showMenuSelector)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "dropdown-backdrop",
                                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showMenuSelector = false))
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-outline-light w-100 d-flex justify-content-between align-items-center",
                                type: "button",
                                id: "scopeDropdown",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false",
                                onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.showScopeSelector = !_ctx.showScopeSelector), ["stop"]))
                              }, [
                                _createElementVNode("span", null, "Scope: " + _toDisplayString(_ctx.scopeFilter === "all"
                                ? "Todos"
                                : _ctx.scopeFilter === "admin"
                                ? "Admin"
                                : "User"), 1),
                                _cache[26] || (_cache[26] = _createElementVNode("i", {
                                  class: "fas fa-chevron-down ms-2",
                                  style: {"font-size":"0.7em"}
                                }, null, -1))
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["dropdown-menu p-2 w-100", { show: _ctx.showScopeSelector }]),
                                "aria-labelledby": "scopeDropdown"
                              }, [
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "radio",
                                    name: "scopeFilter",
                                    id: "scopeAll",
                                    value: "all",
                                    checked: _ctx.scopeFilter === 'all',
                                    onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setScopeFilter('all')))
                                  }, null, 40, _hoisted_29),
                                  _cache[27] || (_cache[27] = _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: "scopeAll"
                                  }, " Todos ", -1))
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "radio",
                                    name: "scopeFilter",
                                    id: "scopeAdmin",
                                    value: "admin",
                                    checked: _ctx.scopeFilter === 'admin',
                                    onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setScopeFilter('admin')))
                                  }, null, 40, _hoisted_31),
                                  _cache[28] || (_cache[28] = _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: "scopeAdmin"
                                  }, " Admin ", -1))
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "radio",
                                    name: "scopeFilter",
                                    id: "scopeUser",
                                    value: "user",
                                    checked: _ctx.scopeFilter === 'user',
                                    onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setScopeFilter('user')))
                                  }, null, 40, _hoisted_33),
                                  _cache[29] || (_cache[29] = _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: "scopeUser"
                                  }, " User ", -1))
                                ])
                              ], 2)
                            ]),
                            (_ctx.showScopeSelector)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 2,
                                  class: "dropdown-backdrop",
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showScopeSelector = false))
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleProfiles, (profile) => {
                          return (_openBlock(), _createElementBlock("th", {
                            key: profile.profileId,
                            class: _normalizeClass(["profile-header text-center", {
                      'column-hovered': _ctx.isColumnHovered(profile.profileId),
                      dimmed:
                        _ctx.hoveredColumn && !_ctx.isColumnHovered(profile.profileId),
                    }]),
                            onMouseenter: ($event: any) => (_ctx.setHover(null, profile.profileId)),
                            onMouseleave: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.clearHover && _ctx.clearHover(...args)))
                          }, [
                            _createElementVNode("div", _hoisted_35, [
                              _withDirectives(_createElementVNode("button", {
                                class: "btn btn-sm btn-link text-white p-0 position-absolute top-0 start-50 translate-middle-x mt-2 hide-col-btn",
                                onClick: _withModifiers(($event: any) => (_ctx.toggleColumnVisibility(profile.profileId)), ["stop"]),
                                title: "Ocultar columna"
                              }, [...(_cache[30] || (_cache[30] = [
                                _createElementVNode("i", { class: "fas fa-eye-slash" }, null, -1)
                              ]))], 8, _hoisted_36), [
                                [_vShow, _ctx.isColumnHovered(profile.profileId)]
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("span", null, _toDisplayString(profile.profileId), 1)
                              ]),
                              _createElementVNode("div", _hoisted_38, [
                                _createElementVNode("input", {
                                  class: _normalizeClass(["form-check-input fs-5 mx-0", {
                            'modified-checkbox': _ctx.isProfileActiveModified(
                              profile.profileId
                            ),
                          }]),
                                  type: "checkbox",
                                  id: `toggle-${profile.profileId}`,
                                  checked: profile.active !== false,
                                  onChange: ($event: any) => (_ctx.toggleProfileActive(profile)),
                                  disabled: _ctx.loading
                                }, null, 42, _hoisted_39)
                              ])
                            ])
                          ], 42, _hoisted_34))
                        }), 128)),
                        _createElementVNode("th", _hoisted_40, [
                          _createElementVNode("button", {
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.createProfile())),
                            class: "btn btn-sm btn-outline-light text-nowrap",
                            title: "Agregar nuevo perfil",
                            disabled: _ctx.addMode
                          }, [...(_cache[31] || (_cache[31] = [
                            _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
                            _createElementVNode("span", null, "Agregar", -1)
                          ]))], 8, _hoisted_41)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_TransitionGroup, {
                    tag: "tbody",
                    name: "row"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMenus, (screen) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: screen.Key,
                          class: _normalizeClass({ 'row-hovered': _ctx.isRowHovered(screen.Key) })
                        }, [
                          _createElementVNode("td", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("i", {
                                    class: _normalizeClass(_ctx.getIconForScreen(screen))
                                  }, null, 2)
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, _toDisplayString(screen.Label), 1),
                                  _createElementVNode("div", _hoisted_48, _toDisplayString(screen.Key), 1)
                                ])
                              ]),
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-link text-white p-0 position-absolute end-0 hide-row-btn",
                                onClick: _withModifiers(($event: any) => (_ctx.toggleMenuVisibility(screen.Key)), ["stop"]),
                                title: "Ocultar pantalla"
                              }, [...(_cache[32] || (_cache[32] = [
                                _createElementVNode("i", { class: "fas fa-eye-slash" }, null, -1)
                              ]))], 8, _hoisted_49)
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleProfiles, (profile) => {
                            return (_openBlock(), _createElementBlock("td", {
                              key: `${screen.Key}-${profile.profileId}`,
                              class: _normalizeClass(["permission-cell text-center", {
                      'column-hovered': _ctx.isColumnHovered(profile.profileId),
                    }]),
                              onMouseenter: ($event: any) => (_ctx.setHover(screen.Key, profile.profileId)),
                              onMouseleave: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.clearHover && _ctx.clearHover(...args)))
                            }, [
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("input", {
                                  class: _normalizeClass(["form-check-input fs-4", {
                          'modified-checkbox': _ctx.isPendingChange(
                            profile.profileId,
                            screen.Key
                          ),
                        }]),
                                  type: "checkbox",
                                  id: `check-${screen.Key}-${profile.profileId}`,
                                  checked: _ctx.hasPermission(profile, screen.Key),
                                  onChange: ($event: any) => (_ctx.togglePermission(profile, screen.Key)),
                                  disabled: _ctx.loading || profile.active === false
                                }, null, 42, _hoisted_52)
                              ])
                            ], 42, _hoisted_50))
                          }), 128)),
                          _cache[33] || (_cache[33] = _createElementVNode("td", { class: "add-profile-cell" }, null, -1))
                        ], 2))
                      }), 128))
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("button", {
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.saveAllChanges())),
                    class: "btn btn-sm btn-primary",
                    disabled: _ctx.loading || !_ctx.hasChanges
                  }, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_57))
                      : (_openBlock(), _createElementBlock("i", _hoisted_58)),
                    _createTextVNode(" " + _toDisplayString(_ctx.loading ? "Guardando..." : "Guardar Cambios"), 1)
                  ], 8, _hoisted_56)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.addMode && _ctx.profiles.length === 0 && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _cache[35] || (_cache[35] = _createElementVNode("i", { class: "fas fa-inbox fa-3x text-muted mb-3" }, null, -1)),
            _cache[36] || (_cache[36] = _createElementVNode("p", { class: "text-muted" }, "No hay perfiles configurados.", -1)),
            _createElementVNode("button", {
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.createProfile())),
              class: "btn btn-sm btn-primary"
            }, [...(_cache[34] || (_cache[34] = [
              _createElementVNode("i", { class: "fas fa-plus" }, null, -1),
              _createTextVNode(" Crear primer perfil ", -1)
            ]))])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading && _ctx.profiles.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [...(_cache[37] || (_cache[37] = [
          _createElementVNode("div", { class: "col-12 text-center py-5" }, [
            _createElementVNode("i", { class: "fas fa-spinner fa-spin fa-3x text-primary" }),
            _createElementVNode("p", { class: "text-muted mt-3" }, "Cargando perfiles...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true)
  ]))
}